import script from "./Uploads.vue?vue&type=script&setup=true&lang=js"
export * from "./Uploads.vue?vue&type=script&setup=true&lang=js"

import "./Uploads.vue?vue&type=style&index=0&id=4107acff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4107acff"]])

export default __exports__